import React from "react";

const FiltersBar = ({
  searchTerm, setSearchTerm,
  seasonFilter, setSeasonFilter, seasons,
  dojos, selectedDojo, handleDojoChange,
  showGroupFilter, groups, groupFilter, setGroupFilter,
  statusFilter, setStatusFilter,
  communeFilter, setCommuneFilter, communes,
  filteredCount,
}) => {
  return (
    <div className="px-5 py-5 sm:px-8">
      <div className="grid grid-cols-1 md:grid-cols-6 gap-3">
        <input
          type="text"
          placeholder="Rechercher (nom, prénom)…"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
        />

        <select
          value={seasonFilter}
          onChange={(e) => setSeasonFilter(e.target.value)}
          className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
        >
          <option value="">Toutes saisons</option>
          {seasons.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>

        {dojos.length > 1 && (
          <select
            onChange={handleDojoChange}
            value={selectedDojo}
            className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
          >
            <option value="">Tous les dojos</option>
            {dojos.map((d) => (
              <option key={d.id} value={d.id}>{d.dojo_nom}</option>
            ))}
          </select>
        )}

        {(selectedDojo || showGroupFilter) && (
          <select
            value={groupFilter}
            onChange={(e) => setGroupFilter(e.target.value)}
            className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
          >
            <option value="">Tous groupes</option>
            {groups.map((g) => (
              <option key={g.id} value={g.nom}>{g.nom}</option>
            ))}
          </select>
        )}

        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
        >
          <option value="">Tous statuts</option>
          <option value="Licencié">Licencié</option>
          <option value="Inscrit">Inscrit</option>
          <option value="Cours d'essai">Cours d'essai</option>
          <option value="Licencié - Arrêt">Licencié - Arrêt</option>
          <option value="Non Licencié - Arrêt">Non Licencié - Arrêt</option>
          <option value="Licencié Hors Club">Licencié Hors Club</option>
          <option value="Ancien Licencié">Ancien Licencié</option>
          <option value="Ancien Licencié et Arrêt">Ancien Licencié et Arrêt</option>
        </select>

        <select
          value={communeFilter}
          onChange={(e) => setCommuneFilter(e.target.value)}
          className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
        >
          <option value="">Toutes communes</option>
          {communes.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
      </div>

      <div className="mt-3 text-sm font-medium text-slate-700 dark:text-slate-200">
        Nombre d'adhérents affichés : {filteredCount}
      </div>
    </div>
  );
};

export default FiltersBar;
